<template>
    <router-link :to="`/smartlog/detail/${item?.id}`" class="card" style="border-radius: 10px; overflow: hidden;">
        <div :style="{
            backgroundImage: `url('${item.main_image ? item.main_image : '/assets/img/empty.png'}')`,
            height: '200px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }" :class="{ 'no-stock': item?.storage?.stock === 0 }">
            <div class="d-flex justify-content-between align-middle m-1">
                <span class="available-badge text-sm">
                    {{ item?.storage?.stock === 0 ? "Tidak Tersedia" : "Tersedia" }}
                </span>
                <span v-can="'material/update_bookmark'" class="btn btn-icon-small rounded-circle" @click.stop.prevent="onBookmark" style="cursor: pointer; background-color: aliceblue;">
                    <i class="fa fa-lg text-blue" :class="item?.is_bookmark ? 'fa-bookmark' : 'fa-bookmark-o'"></i>
                </span>
            </div>
        </div>

        <div class="card-body" :class="{ 'no-stock': item?.storage?.stock === 0 }">
            <h1 class="card-title text-truncate">
                {{ item?.name }}
            </h1>
            <h6>{{ item?.code }}</h6>
            <div class="text-muted small mb-1">
                {{ item?.category?.name }} | {{ item?.sub_category?.name }}
            </div>
            <div class="mb-1">
                <i class="fa fa-home fa-lg mr-1" style="color: lightslategray;"></i>
                <span style="color: black;">
                    {{ item?.storage?.warehouse?.name }}
                </span>
            </div>
            <div class="stock-badge mb-1">
                Stok : {{ item?.storage?.stock }} {{ item?.storage?.material_unit?.name }}
            </div>
            <div>
                <i class="fa fa-map-marker fa-lg mr-1" style="color: lightslategray;"></i>
                <span style="color: black;">
                    {{ item?.storage?.unit?.name }}
                </span>
            </div>
        </div>
        <div class="card-footer border-0 p-1" :class="{ 'bg-white': item?.storage?.stock !== 0 }">
            <div class="d-flex justify-content-start align-items-center" v-if="useAction">
                <button v-if="item.can_manage" type="button" class="mr-1 btn btn-sm btn-outline-danger" @click.prevent="onDestroy">
                    <i class="fa fa-trash"></i>
                </button>
                <router-link v-if="item.can_manage" :to="`/smartlog/edit/${item?.id}`" class="mr-1 btn btn-sm btn-outline-primary">
                    <i class="fa fa-pencil"></i>
                </router-link>
                <router-link v-if="item.can_manage" :to="`/riwayat-material?material_id=${item?.id}`"
                    class="mr-1 btn btn-sm btn-outline-primary">
                    Riwayat Masuk/Keluar
                </router-link>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: "MaterialCard",
    props: {
        item: {
            type: Object,
            required: true
        },
        useAction: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onBookmark() {
            this.$emit('bookmark', this.item)
        },
        onDestroy() {
            this.$emit('destroy', this.item)
        }
    }
}
</script>



<style>
 .available-badge {
    background-color: rgb(21, 133, 11);
    padding: 3px 10px;
    border-radius: 10px;
    color: white;
    display: inline-flex; /* Ubah dari inline-block */
    align-items: center; /* Rata tengah vertikal */
    justify-content: center; /* Rata tengah horizontal */
    height: 27px; /* Beri tinggi tetap (opsional) */
}

.stock-badge {
    background-color: rgb(218, 241, 250);
    padding: 5px 10px 5px 10px;
    border-radius: 5px;
    color: rgb(25, 125, 167);
    font-weight: bold;
    width: fit-content;
}

.no-stock {
  background-color: #f8f9fa !important; /* abu muda */
  color: #6c757d !important; /* teks abu */
  filter: grayscale(100%); /* efek hitam putih */ 
}

</style>